import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar os arquivos de tradução
import ptBR from './locales/pt-BR/common.json';
import ptPT from './locales/pt-PT/common.json';
import enUS from './locales/en-US/common.json';
import frFR from './locales/fr-FR/common.json';
import esES from './locales/es-ES/common.json';

const resources = {
  'pt-BR': {
    translation: ptBR,
  },
  'pt-PT': {
    translation: ptPT,
  },
  'en-US': {
    translation: enUS,
  },
  'fr-FR': {
    translation: frFR,
  },
  'es-ES': {
    translation: esES,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React já faz escape por padrão
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
